import {
  CheckCircleIcon,
  FulfillmentIcon,
  OrdersIcon,
  ReturnIcon,
  WarningIcon,
  TakeIcon,
  LookIcon,
  PerformanceIcon,
  ProductsIcon,
  ClientsIcon,
  CalendarIcon,
  StoreIcon,
  KeyActionIcon,
  SkuTrackerIcon,
  ShoppingBagIcon,
  AlterationIcon,
} from 'sharedComponents/Icons';

import * as toggles from './featureToggleNames';
import { messageTypes } from './message';

export { default as STATES_USA } from './states';
export { default as STORE_LIST } from './stores';
export { default as TIMEZONE_NAMES } from './account';

export * from './checkout';
export * from './orders';
export * from './filters';
export * from './product';
export * from './search';
export * from './message';
export * from './performance';

export const EMAIL_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export { PACKAGING_TYPES, PACKAGING_OPTIONS, GIFT_NOTE_TYPES, NOTE_OPTIONS, GIFT_ERRORS } from './giftOptions';
export { DEFAULT_GROUP_DATA, GROUPS_SORT_BY, SUPERUSER_AD_GROUP, AD_GROUP_LIST } from './groups';
export { NOTES_FILTERS } from './notes';

export const GROUPS = {
  MANAGER: 'G_OSP_Manager',
  STYLIST: 'G_OSP_DigitalStylist',
  TESTER: 'G_OSP_DigitalStylist_TEST',
};
export const DIGITAL_STYLIST_GROUPS = [
  'G_OSP_DigitalStylist',
  'G_OSP_NM_DigitalStylist_TEST',
  'G_OSP_NM_DIGITAL_STYLIST',
  'G_OSP_NM_DIGITAL_CLIENT_ADVISOR',
  'G_OSP_NM_DIGITAL_ClIENT_ADVISOR_TEST',
];

export const BRAND_PROFILES_LIST = ['BG', 'NM'];
export const BRAND_PROFILES = { BG: 'BG', NM: 'NM' };

// String value which should be used for brand identifier of logged user through `custom:groups` prop of Cognito payload
export const BG_BRAND_IDENTIFIER = 'G_OSP_BG';

export const GROUPS_COVER_COLORS = ['#000000', '#00857c', '#ed5a61', '#a000a3', '#0069c4', '#009d69'];

export const ROLES = {
  MANAGER: 'manager',
  STYLIST: 'stylist',
  CLIENT: 'client',
  TESTER: 'tester',
};

export const VOICE_CALL_STATUS_TEXT = {
  ACCEPT: 'CALL CONNECTED',
  CONNECT: 'RINGING...',
  DIALING: 'DIALING...',
  DISCONNECT: 'DISCONNECTED',
  ERROR: 'CALL ERROR',
  MUTED: 'MUTED',
  OFFLINE: 'NOT CONNECTED OR EXPIRED TOKEN',
};

export const BREAKPOINTS = {
  MOBILE: { value: 0, name: 'mobile' },
  TABLET: { value: 768, name: 'tablet' },
  DESKTOP: { value: 1024, name: 'desktop' },
};

export const STYLYZE_LOOKS_LINKS = [
  { title: 'My Looks', key: 'my-looks' },
  { title: "Discover Women's", key: 'womens-looks' },
  { title: "Discover Men's", key: 'mens-looks' },
];

// TODO: Fix Amplify logout flow
export const logoutUrl = (authConfig) =>
  `https://${authConfig.oauth.domain}/logout?client_id=${authConfig.userPoolWebClientId}` +
  `&logout_uri=${authConfig.oauth.redirectSignOut}`;

export const NMVIP = 'NMVIP';

export const shipmentMethodsMap = [
  {
    id: 'SL0',
    name: 'Same Day Delivery',
    term: 'Order by noon, weekdays only',
  },
  {
    id: 'SL1',
    name: 'Next Business Day',
    term: '1-2 business days',
  },
  {
    id: 'SL2',
    name: 'Two Day Shipping',
    term: '2-3 business days',
  },
  {
    id: 'SL3',
    name: 'Standard Delivery',
    term: '3-5 business days',
  },
  {
    id: 'SL4',
    name: 'Economy',
    term: '5-8 business days',
  },
];

export const PHONE_TYPES = [
  { name: 'Phone', value: 'phone' },
  { name: 'Mobile', value: 'mobile' },
  { name: 'Home', value: 'home' },
];

export const statusCodesMap = {
  RP: { type: 'Placed', text: 'Ready to Print' },
  RD: { type: 'Placed', text: 'Ready to Dropship' },
  DS: { type: 'In-fulfillment', text: 'Dropship' },
  PT: { type: 'In-fulfillment', text: 'Printed Warehouse or Store Ticket' },
  VS: { type: 'Shipped', text: 'Verified Shipped' },
  BO: { type: 'Issue', text: 'Back Ordered' },
  CX: { type: 'Issue', text: 'Cancelled', isNegative: true },
  RT: { type: 'Returned', text: 'Returned Product Received', icon: 'Returned', isNegative: true },
  RX: { type: 'Returned', text: 'Return Credit before Merchandise Received', icon: 'Returned', isNegative: true },
  RN: {
    type: 'Returned',
    text: 'Return Credit without the expectation of Merchandise ever coming back',
    icon: 'Returned',
    isNegative: true,
  },
  PL: { type: 'Issue', text: 'Parcel Loss', isNegative: true },
  PD: { type: 'Issue', text: 'Parcel Damage', isNegative: true },
  RB: { type: 'Issue', text: 'Reply Back' },
  CB: {
    type: 'Issue',
    text: 'Customer Charge Back',
    isNegative: true,
  },
  RI: { type: 'Ignore', text: 'Reintstated' },
  RETURN: { type: 'Returned', text: 'Returned Product Received', icon: 'Returned', isNegative: true },
  SEND: { type: 'Send', text: '' },
  TAKE: { type: 'Take', text: '' },
  BOPS: { icon: 'BOPS' },
};

export const ICON_COLORS = {
  GREEN: '#009d69',
  ORANGE: '#ef6c00',
  RED: '#b00000',
};

export const bopsSubStatusMap = {
  'store allocation': ICON_COLORS.ORANGE,
  'found on floor': ICON_COLORS.ORANGE,
  'in transit': ICON_COLORS.GREEN,
  'delivered to store': ICON_COLORS.GREEN,
  'ready for pick up': ICON_COLORS.GREEN,
  'package picked up': ICON_COLORS.GREEN,
  'item returned': ICON_COLORS.GREEN,
};

export const ICON_MAP = {
  Placed: {
    icon: CheckCircleIcon,
    color: ICON_COLORS.ORANGE,
  },
  'In-fulfillment': {
    icon: FulfillmentIcon,
    color: ICON_COLORS.ORANGE,
  },
  Shipped: {
    icon: OrdersIcon,
    color: ICON_COLORS.GREEN,
  },
  Returned: {
    icon: ReturnIcon,
    color: ICON_COLORS.RED,
  },
  Issue: {
    icon: WarningIcon,
    color: ICON_COLORS.RED,
  },
  Ignore: {
    icon: WarningIcon,
    color: ICON_COLORS.RED,
  },
  Send: {
    icon: OrdersIcon,
    color: ICON_COLORS.GREEN,
  },
  Take: {
    icon: TakeIcon,
    color: ICON_COLORS.GREEN,
  },
  BOPS: {
    icon: StoreIcon,
    color: ICON_COLORS.GREEN,
  },
};

export const PRICE_ADJUST = {
  MAX_PRICE: 0.3,
  ERROR_MSG: 'Cannot adjust more than 30%',
  INVALID_MSG: 'Invalid adjustment',
  TYPES: [
    { value: 'DOLLAR', name: 'Dollar Off' },
    { value: 'PERCENT', name: 'Percent Off' },
    { value: 'OVERRIDE', name: 'Price override' },
  ],
  TYPES_CHARS: {
    DOLLAR: '- $',
    PERCENT: '%',
    OVERRIDE: '$',
  },
  REASONS: [
    { value: 'Competitive Price Match', name: 'Competitive Price Match' },
    { value: 'Omni Price Match', name: 'Omni Price Match' },
    { value: 'Promotion Error', name: 'Promotion Error' },
  ],
};

export const NO_IMAGE_AVAILABLE = {
  NM: 'https://neimanmarcus.scene7.com/is/image/NeimanMarcus/vnt_error',
  BG: '/no_image_available_bg.png',
};

export const SWATCH_PLACEHOLDER = {
  NM: '/swatch_NM.jpg',
  BG: '/swatch_BG.jpg',
};

export const IMAGE_HEAD_PROTOCOL = 'https:';

export const PRODUCT_LISTING_DEFAULT_COUNT = 40;

export const DESIGNER_CATEGORY_IDS = [
  'cat000019',
  'cat000199',
  'cat000160',
  'cat000339',
  'cat59430736',
  'cat000226',
  'cat000488',
  'cat000562',
];

export const PLP_SORTING_FILTERS = [
  {
    name: 'Best Match',
    sortBy: '',
    sortDirection: '',
  },
  {
    name: 'Price: Lowest first',
    sortBy: 'PRICE',
    sortDirection: 'ASC',
  },
  {
    name: 'Price: Highest first',
    sortBy: 'PRICE',
    sortDirection: 'DESC',
  },
  {
    name: 'Newest first',
    sortBy: 'CREATED',
    sortDirection: 'DESC',
  },
  {
    name: 'Oldest first',
    sortBy: 'CREATED',
    sortDirection: 'ASC',
  },
];

export const OFFSET_TOP_TO_SHOW_BACK_TO_TOP = 100;

export const PIMSKU_MAX_LENGTH = 20;

export const PAYMENT_IFRAME_HEIGHT = '316px';

export const GLOBAL_SEARCH_MODULES = [
  {
    name: 'clients',
    path: '/clients/central/search',
  },
  {
    name: 'orders',
    path: '/orders',
    state: { clearFilters: true },
    hideConditions: ['isBackOfHouseUser'],
  },
  {
    name: 'products',
    path: '/products/catalog/search',
  },
  {
    name: 'messages',
    path: 'clienteling/inbox',
    hideConditions: ['isNotStatefulGlobalNav', 'isBackOfHouseUser'],
  },
  {
    name: 'trackers',
    path: '/products/catalog/tracker',
    hideConditions: ['isNotStatefulGlobalNav'],
  },
];

export const GLOBAL_NAVIGATION_TABS = {
  home: {
    path: '/home',
  },
  search: {
    path: '/search',
  },
  messages: {
    path: '/clienteling',
  },
  alerts: {
    path: '/notifications',
  },
  style: {
    path: '/products',
  },
  clients: {
    path: '/clients',
  },
};

export const MORE_MENU_ITEMS = [
  { title: 'Calendar', path: '/calendar', icon: CalendarIcon },
  { title: 'Clients', path: '/clients', icon: ClientsIcon },
  { title: 'Products', path: '/products/catalog/browse', toggle: toggles.STYLE_CENTRAL_TOGGLE, icon: ProductsIcon },
  { title: 'Performance', path: '/performance', toggle: toggles.PERFORMANCE_MODULE, icon: PerformanceIcon },
  { title: 'Orders', path: '/orders', icon: OrdersIcon },
  { title: 'Looks', path: '/looks?page=landing-page', icon: LookIcon, isLooksApp: true },
];

export const NOTIFICATIONS_FILTER = [
  {
    value: 'alt',
    name: 'Alterations',
  },
  {
    value: 'pro',
    name: 'Profile Edits',
  },
  {
    value: 'ord',
    name: 'Orders',
  },
  {
    value: 'rtc',
    name: 'Reason to Contact',
  },
  {
    value: 'sku',
    name: 'SKU Tracker',
  },
];

export const NOTIFICATIONS_FILTER_NEW = [
  {
    value: 'alt',
    name: 'Alterations',
    icon: AlterationIcon,
  },
  {
    value: 'rtc',
    name: 'Client Connects',
    icon: KeyActionIcon,
  },
  {
    value: 'ord',
    name: 'Orders',
    icon: OrdersIcon,
  },
  {
    value: 'onl',
    name: 'Shared Shopping Bags',
    icon: ShoppingBagIcon,
    toggleName: toggles.CLIENT_BAG_SHARING,
  },
  {
    value: 'sku',
    name: 'SKU Tracker',
    icon: SkuTrackerIcon,
  },
];

export const NOTIFICATIONS_POSTPONE = [
  {
    value: '3h',
    name: 'Later today',
  },
  {
    value: '24h',
    name: 'Tomorrow',
  },
  {
    value: '7d',
    name: 'Next Week',
  },
];

export const LOYALTY_CARD_LABELS = {
  'Promotional Card': 'Promo Card',
  'InCircle Point Card': 'Point Card',
  'InCircle Perk': 'Perk Card',
};

export const ATTACHMENTS_SIZE_LIMIT = {
  [messageTypes.email]: {
    file: 9,
    message: 10,
  },
  [messageTypes.sms]: {
    file: 4.5,
    message: 5,
  },
};

export const ATTACHMENTS_ACCEPT_TYPES = '.png,.jpg,.gif,.pdf';

export const COGNITO_EMAIL_VALIDATION = {
  RESPONSE_TYPES: {
    EXISTS: 'UsernameExistsException',
    INVALID: 'UserLambdaValidationException',
  },
  ERROR_TYPES: {
    EXISTED: 'existed email',
    INVALID: 'invalid email',
    ERROR: 'error',
  },
};

export const OSP_PRODUCT_SHARE_EXPIRY = 'osp_lxts';

export const OSP_PRODUCT_SHARE_EXPIRY_DATE = 1;

export const DAYS_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export const CLIENT_CREATION_MESSAGE_SUBJECTS = {
  NM: {
    clientCreation: 'Welcome to Neiman Marcus!',
    cmdLinking: 'Your Neiman Marcus account has been updated',
  },
  BG: {
    clientCreation: 'Welcome to Bergdorf Goodman!',
    cmdLinking: 'Your Bergdorf Goodman account has been updated',
  },
};

export const PRODUCT_ROOT_CATEGORY_IDS = {
  BG: {
    men: 'cat202802',
    women: 'cat01',
    home: 't2cat392904',
  },
  NM: {
    men: 'cat000470',
    women: 'cat01',
    home: 'cat000553',
  },
};

export const BRAND_TITLES = {
  BG: 'Bergdorf Goodman',
  NM: 'Neiman Marcus',
};

export const INBOX_FILTER = [
  {
    value: 'unread',
    name: 'Unread By Client',
  },
  {
    value: 'undelivered',
    name: 'Not Delivered to Client',
  },
];
export const PERFORMANCE_FILTER = [
  {
    value: 'TODAY',
    name: 'Today',
  },
  {
    value: 'WEEK_TO_DATE',
    name: 'Week to Date',
  },
  {
    value: 'MONTH_TO_DATE',
    name: 'Month to Date',
  },
  {
    value: 'QUARTER_TO_DATE',
    name: 'Quarter to Date',
  },
  {
    value: 'YEAR_TO_DATE',
    name: 'Year to Date',
  },
  {
    value: 'CUSTOM',
    name: 'Custom Range',
  },
];

export const PERFORMANCE_ASSOCIATE_FILTER = [
  {
    value: 'WEEK_TO_DATE',
    name: 'This Week',
  },
  {
    value: 'MONTH_TO_DATE',
    name: 'This Month',
  },
  {
    value: 'QUARTER_TO_DATE',
    name: 'This Quarter',
  },
  {
    value: 'YEAR_TO_DATE',
    name: 'This Year',
  },
];

export const PERFORMANCE_DEFAULT_DATES = {
  today: 'TODAY',
  customRange: 'CUSTOM',
};

// The maximum length of search query, when search request should still not be sent.
export const SEARCH_LENGTH_THRESHOLD = 2;

export const STORE_MANAGER_LIST = {
  '0001': {
    brand: 'NM',
    storeId: '0001',
    storeName: 'Dallas - Downtown',
  },
  '0002': {
    brand: 'NM',
    storeId: '0002',
    storeName: 'Dallas - Northpark',
  },
  '0003': {
    brand: 'NM',
    storeId: '0003',
    storeName: 'Fort Worth',
  },
  '0004': {
    brand: 'NM',
    storeId: '0004',
    storeName: 'Houston Galleria',
  },
  '0005': {
    brand: 'NM',
    storeId: '0005',
    storeName: 'Bal Harbour',
  },
  '0006': {
    brand: 'NM',
    storeId: '0006',
    storeName: 'Atlanta',
  },
  '0007': {
    brand: 'NM',
    storeId: '0007',
    storeName: 'St. Louis',
  },
  '0009': {
    brand: 'NM',
    storeId: '0009',
    storeName: 'Northbrook',
  },
  '0010': {
    brand: 'NM',
    storeId: '0010',
    storeName: 'Beverly Hills',
  },
  '0011': {
    brand: 'NM',
    storeId: '0011',
    storeName: 'Fashion Island',
  },
  '0012': {
    brand: 'NM',
    storeId: '0012',
    storeName: 'San Francisco',
  },
  '0013': {
    brand: 'NM',
    storeId: '0013',
    storeName: 'Willow Bend',
  },
  '0014': {
    brand: 'NM',
    storeId: '0014',
    storeName: 'Westchester',
  },
  '0015': {
    brand: 'NM',
    storeId: '0015',
    storeName: 'Las Vegas',
  },
  '0016': {
    brand: 'NM',
    storeId: '0016',
    storeName: 'San Diego',
  },
  '0017': {
    brand: 'NM',
    storeId: '0017',
    storeName: 'Oakbrook',
  },
  '0019': {
    brand: 'NM',
    storeId: '0019',
    storeName: 'Michigan Ave',
  },
  '0020': {
    brand: 'NM',
    storeId: '0020',
    storeName: 'Boston',
  },
  '0023': {
    brand: 'NM',
    storeId: '0023',
    storeName: 'Tysons Galleria',
  },
  '0024': {
    brand: 'NM',
    storeId: '0024',
    storeName: 'Palo Alto',
  },
  '0025': {
    brand: 'NM',
    storeId: '0025',
    storeName: 'Short Hills',
  },
  '0027': {
    brand: 'NM',
    storeId: '0027',
    storeName: 'Denver',
  },
  '0028': {
    brand: 'NM',
    storeId: '0028',
    storeName: 'Paramus',
  },
  '0029': {
    brand: 'NM',
    storeId: '0029',
    storeName: 'Scottsdale',
  },
  '0030': {
    brand: 'NM',
    storeId: '0030',
    storeName: 'King of Prussia',
  },
  '0031': {
    brand: 'NM',
    storeId: '0031',
    storeName: 'Ala Moana',
  },
  '0033': {
    brand: 'NM',
    storeId: '0033',
    storeName: 'Troy',
  },
  '0034': {
    brand: 'NM',
    storeId: '0034',
    storeName: 'Coral Gables',
  },
  '0035': {
    brand: 'NM',
    storeId: '0035',
    storeName: 'Tampa Bay',
  },
  '0036': {
    brand: 'NM',
    storeId: '0036',
    storeName: 'Orlando',
  },
  '0037': {
    brand: 'NM',
    storeId: '0037',
    storeName: 'San Antonio',
  },
  '0038': {
    brand: 'NM',
    storeId: '0038',
    storeName: 'Boca Raton',
  },
  '0101': {
    brand: 'NM',
    storeId: '0101',
    storeName: 'Austin',
  },
  '0102': {
    brand: 'NM',
    storeId: '0102',
    storeName: 'Charlotte',
  },
  '0103': {
    brand: 'NM',
    storeId: '0103',
    storeName: 'Natick',
  },
  '0105': {
    brand: 'NM',
    storeId: '0105',
    storeName: 'Topanga',
  },
  '0111': {
    brand: 'NM',
    storeId: '0111',
    storeName: 'Roosevelt Field',
  },
  '0063': {
    brand: 'BG',
    storeId: '0063',
    storeName: "BG WOMEN'S STORE",
  },
  '0064': {
    brand: 'BG',
    storeId: '0064',
    storeName: "BG MEN's STORE",
  },
};

export const DEFAULT_GM_STORE = {
  NM: STORE_MANAGER_LIST['0002'],
  BG: STORE_MANAGER_LIST['0063'],
};

export const DEFAULT_USER_IMAGE_MAP = {
  NM: '/logo_NM.jpg',
  BG: '/logo_BG.jpg',
  NMVIP: '/logo_NMVIP.jpg',
};
